import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';

import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';
import PagedData from '../Components/PagedData/index.jsx';

import API from '../Services/ContentFeed/index.jsx';

import Store from '../Store/index.js';
import ContentFeedList from '../Components/ContentFeedList/index.jsx';

export default function(document) {
  var element = document.getElementById('cs-bookmark-feed');

  if (element) {
    var api = new API(null, null, true);    // Passing bookmarked value true
    var WrappedComponent = PagedData(ContentFeedList, api);

    var output = [];
    output.push(
      <WrappedComponent key="component" />
    );

    ReactDom.render(
      <ErrorBoundary>
        <Provider store={Store}>
          {output}
        </Provider>
      </ErrorBoundary>,
      element
    );
  }
};
